import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrentCartItemAvailability } from 'app/features/cart';
import { Async } from 'app/store';

@Component({
  selector: 'app-cart-current-list-item-availability',
  templateUrl: './cart-current-list-item-availability.component.html',
  styleUrls: ['./cart-current-list-item-availability.component.scss'],
})
export class CartCurrentListItemAvailabilityComponent implements OnInit {
  /**
   * Current cart availability array
   */
  @Input() availabilities: Async<CurrentCartItemAvailability[]>;

  /**
   * Current cart item ID
   */
  @Input() currentCartItemId: number;
  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    console.log('availability: ');
    console.log(this.availabilities);
  }

  translateKey(key: string) {
    if (key.toLowerCase().includes('on request') && key.toLowerCase() !== 'on request') {
      const keySplit = key.split('weeks');
      return keySplit[0] + this.translateService.instant('CART.WEEKS_ON_REQUEST');
    } else {
      return key;
    }
  }
}
